import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, KeyRound, Upload } from "lucide-react";
import { Input } from "@/components/ui/input";

export const GA = `${process.env.REACT_APP_BACKEND_URL}/api/ads/google`;
export const lei = (v) => `${Number(v || 0).toLocaleString("ro-RO", { maximumFractionDigits: 2 })} lei`;

export const GoogleConnect = ({ status, onConnected }) => {
  const [tok, setTok] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { const r = await axios.put(`${GA}/token`, { refresh_token: tok }); setTok(""); toast.success("Google Ads conectat"); onConnected(r.data); }
    catch (e) { toast.error(e.response?.data?.detail || e.message, { duration: 10000 }); }
    setBusy(false);
  };
  return (
    <div className="space-y-3 rounded-xl border border-amber-400/40 bg-amber-400/5 p-5" data-testid="google-connect">
      <p className="flex items-center gap-2 font-semibold text-amber-200"><KeyRound className="h-4 w-4" /> Google Ads nu e conectat</p>
      <p className="text-sm text-rose-300" data-testid="google-connect-error">{status?.error}</p>
      <ol className="list-decimal space-y-1 pl-5 text-xs text-zinc-300">
        <li>Google Cloud → APIs & Services → Credentials → clientul OAuth (tip Web) → la <b>Authorized redirect URIs</b> adaugă <code className="rounded bg-zinc-800 px-1">https://developers.google.com/oauthplayground</code>.</li>
        <li>La <b>OAuth consent screen</b> pune <b>Publishing status = In production</b> (altfel tokenul expiră în 7 zile).</li>
        <li>Pe <b>developers.google.com/oauthplayground</b> → rotița dreapta-sus → bifează „Use your own OAuth credentials” → pune Client ID și Client Secret.</li>
        <li>Scrie scope-ul <code className="rounded bg-zinc-800 px-1">https://www.googleapis.com/auth/adwords</code> → Authorize APIs (cu bragusidea01@gmail.com) → Exchange authorization code for tokens → copiază <b>Refresh token</b> aici.</li>
      </ol>
      <div className="flex gap-2">
        <Input data-testid="google-token-input" value={tok} onChange={(e) => setTok(e.target.value)} placeholder="1//0…" className="font-mono text-xs" />
        <button data-testid="google-token-save" onClick={save} disabled={busy || !tok.trim()} className="flex shrink-0 items-center gap-1.5 rounded-full bg-amber-400 px-4 text-sm font-semibold text-zinc-950 disabled:opacity-50">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />} Conectează
        </button>
      </div>
    </div>
  );
};
